import { Box, styled, Typography } from "@mui/material";
import {
  BottomActionButton,
  SecondaryActionButton,
} from "@components";

export const SemiBold = styled("span")({
  fontWeight: 600,
});

export const ContentBox = styled(Box)({
  marginBottom: "48px",
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  gap: "16px",
  width: "100%",
});

export const LogoWrapper = styled(Box)({
  width: "100%",
  display: "flex",
  justifyContent: "center",
});

export const LogoImage = styled("img")({
  width: 107,
  height: 56,
  objectFit: "contain",
});

export const TitleTypography = styled(Typography)({
  fontFamily: "Poppins",
  fontWeight: 500,
  fontSize: "20px",
  lineHeight: "27px",
  letterSpacing: "0.15px",
  textAlign: "left",
  width: "100%",
});

export const BodyTypography = styled(Typography)({
  fontFamily: "Poppins",
  fontWeight: 400,
  fontSize: "16px",
  lineHeight: "23px",
  letterSpacing: "0.5px",
  textAlign: "left",
  width: "100%",
});

export const SmallBodyTypography = styled(Typography)({
  fontFamily: "Poppins",
  fontWeight: 400,
  fontSize: "14px",
  lineHeight: "23px",
  letterSpacing: "0.5px",
  textAlign: "left",
  width: "100%",
});

export const ButtonsRow = styled(Box)({
  display: "flex",
  flexDirection: "row",
  flexWrap: "nowrap",
  gap: "8px",
  justifyContent: "flex-start",
  alignItems: "stretch",
});

export const StyledSecondaryActionButton = styled(SecondaryActionButton)({
  flex: "0 1 auto",
  minWidth: "215px",
});

export const StyledBottomActionButton = styled(BottomActionButton)({
  gap: 6,
  flex: "1 1 auto",
  minWidth: "215px",
  whiteSpace: "nowrap",
});
